import React, {memo, useCallback, useState, useMemo, useEffect} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {useLocalization} from "../../../../hooks/localization"
import {useRPC} from "../../../../hooks/rpc"
export const ErrorLogsScreen = memo(function ErrorLogsScreen() {
    const [rpc] = useRPC()
    const {t} = useLocalization()
    const [data, setData] = useState<string[]>([])

    const onPressRefresh = useCallback(() => {
        rpc.getServiceErrorLog().then(r => setData(r))
    }, [rpc])

    const buttons = useMemo(
        () => [
            {
                text: t("refresh"),
                className: "blue",
                onClick: onPressRefresh
            }
        ],
        [t, onPressRefresh]
    )

    useEffect(() => {
        rpc.getServiceErrorLog().then(r => setData(r))
    }, [rpc])

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer
                className="service-edit"
                buttons={buttons}
                backUrl="/settings/logs"
                searchable={false}
            >
                <div className="unknown-logs">{data != null && data.map((r, i) => <span key={i}>{r}</span>)}</div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
